
//Helper to open a page either in current tab or new tab
export function openUrl(url, params, blank = false) {

  //Convert to string if URL object given
  if (url instanceof URL) {
    url = url.toString()
  }

  //Construct query string from params
  if (params) {
    const search = getURLSearchParams(params)
    url = search.size ? `${url}?${search}` : url
  }

  //Open in new tab
  if (blank) {
    window.open(url, '_blank') //`_blank${Date.now()}`
  }
  else {
    window.location.href = url
  }
}

//Helper to join URL paths
export function joinPaths(...args) {
  const paths = []
  for (let path of args) {
    if (path === null || path === undefined || path === '/') {
      continue
    }
    path = String(path)
    if (path !== '') {
      paths.push(path)
    }
  }
  return paths
    .join('/')
    .replace(/([^:])(\/\/+)/g, '$1/')
    .replace(/^\/\//, '/')
}

//Get URL search params
export function getURLSearchParams(params) {

  //Initialize
  const search = new URLSearchParams()

  //Nothing to append
  if (!params) {
    return search
  }

  //Append params (this must be done like this to properly handle arrays)
  Object
    .entries(params)
    .forEach(([key, value]) => {
      appendSearchParams(search, key, value)
    })

  //Return
  return search
}

//Private helper to convert a value to string and append to search params
function appendSearchParams(search, key, value) {
  if (Array.isArray(value)) {
    value.forEach((item) => {
      appendSearchParams(search, `${key}[]`, item)
    })
  }
  else if (typeof value === 'object' && value !== null) {
    Object.entries(value).forEach(([subKey, subValue]) => {
      appendSearchParams(search, `${key}[${subKey}]`, subValue)
    })
  }
  else {
    if (value?.toString) {
      search.append(key, value.toString())
    }
  }
}
